'use strict';

var React = require('react');
var injectSheet = require('react-jss');
var PropTypes = require('prop-types');
var Caret = require('react-icons/lib/fa/caret-left');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var injectSheet__default = /*#__PURE__*/_interopDefaultLegacy(injectSheet);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var Caret__default = /*#__PURE__*/_interopDefaultLegacy(Caret);

var styles = {
  container: {
    background: '#202020',
    color: '#fff',
    width: '100%',
    padding: '10px 20px',
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px'
  },
  button: {
    borderRadius: '4px',
    color: '#fff',
    textDecoration: 'none',
    background: '#000',
    padding: '8px 12px',
    display: 'flex',
    alignItems: 'center',
    marginRight: '14px'
  }
};

var LessonBar = function LessonBar(_ref) {
  var classes = _ref.classes,
      id = _ref.id,
      title = _ref.title;
  return /*#__PURE__*/React__default["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React__default["default"].createElement("a", {
    className: classes.button,
    href: "/lessons/lesson/".concat(id)
  }, /*#__PURE__*/React__default["default"].createElement(Caret__default["default"], null), " Back"), /*#__PURE__*/React__default["default"].createElement("span", null, "You're working on your lesson, \"", title, "\"")));
};

LessonBar.propTypes = {
  /** Id of the lesson */
  id: PropTypes__default["default"].string,

  /** Title of the lesson */
  title: PropTypes__default["default"].string,

  /** Additional className if you want to restyle component */
  className: PropTypes__default["default"].string
};
var index = injectSheet__default["default"](styles)(LessonBar);

module.exports = index;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// /codebuild/output/src1478882582/src/pobble-app/client/~/pobble-components/dist/lesson-bar/index.js